import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Schemes from "./pages/Schemes";
import Officers from "./pages/Officers";
import Employees from "./pages/Employees";

import DepartmentList from "./pages/Departments/Index";



//  Deparments pages here
import Asthapna from "./pages/Departments/Asthapna";
import Bandhkam from "./pages/Departments/Bandhkam";
import Krishi from "./pages/Departments/Krishi";
import Lekha from "./pages/Departments/Lekha";
import MahilaBal from "./pages/Departments/MahilaBal";
import MSGRYojana from "./pages/Departments/MSGRYojana";
import Panchayat from "./pages/Departments/Panchayat";
import Pashu from "./pages/Departments/Pashu";
import Shikshan from "./pages/Departments/Shikshan";
import SRJAbhiyan from "./pages/Departments/SRJAbhiyan";
import SwachhBharat from "./pages/Departments/SwachhBharat";

import Gallery from "./pages/Gallery";
import Ministers from "./pages/Ministers";






function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="schemes" element={<Schemes />} />
          <Route path="officers" element={<Officers />} />
          <Route path="employees" element={<Employees />} />
          <Route path="departments" element={<DepartmentList />} />
          <Route path="departments/aasthapna" element={<Asthapna />} />
          <Route path="departments/lekha" element={<Lekha />} />

         {/* ===== Departments Routes ===== */}
        <Route path="/departments/aashtapna" element={<Asthapna />} />
        <Route path="/departments/bandhkam" element={<Bandhkam />} />
        <Route path="/departments/krishi" element={<Krishi />} />
        <Route path="/departments/lekha" element={<Lekha />} />
        <Route path="/departments/mahila-bal" element={<MahilaBal />} />
        <Route path="/departments/msgr-yojana" element={<MSGRYojana />} />
        <Route path="/departments/panchayat" element={<Panchayat />} />
        <Route path="/departments/pashu" element={<Pashu />} />
        <Route path="/departments/shikshan" element={<Shikshan />} />
        <Route path="/departments/srj-abhiyan" element={<SRJAbhiyan />} />
        <Route path="/departments/sbm" element={<SwachhBharat />} />
          <Route path="/gallery" element={<Gallery />} />

          <Route path="/ministers" element={<Ministers />} />
          

        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
